import { render, staticRenderFns } from "./AssPersonDetail.vue?vue&type=template&id=72b7442c&scoped=true"
import script from "./AssPersonDetail.vue?vue&type=script&lang=js"
export * from "./AssPersonDetail.vue?vue&type=script&lang=js"
import style0 from "./AssPersonDetail.vue?vue&type=style&index=0&id=72b7442c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b7442c",
  null
  
)

export default component.exports